import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  container: {flexDirection: 'row', justifyContent: 'space-between'},
});
